import { useParticipationsSuspense } from '../api/list-participations';
import { useParams } from 'react-router-dom';
import { Flyout } from '@/shared/components/flyout';
import { ErrorFrame } from '@/shared/components/error-frame';
import { Loader } from '@/shared/components/ui/loader';
import { useQueryParams } from '@/hooks/shared/use-query-params';
import { ParticipationPanel } from '../components/participation-panel';
import { ParticipationList } from '../components/participation-list';
import { participationToListItem } from '../utils/participation-list';
import { Card } from '@/shared/components/ui/card';
import { useAuth } from '@/hooks/auth/use-auth';
import { MembershipRole } from '@/types/api/membership';
import { useUpdateParticipationCollected } from '../api/update-participation-collected';

const USER_ID_KEY = 'userId';

export function Participations() {
  const { removeQueryParamByKey, getQueryParamByKey, setQueryParam } = useQueryParams();
  const userId = getQueryParamByKey(USER_ID_KEY);
  const saleId = useParams().saleId!;
  const { context } = useAuth();

  const { data: participations } = useParticipationsSuspense({ saleId, params: { include: ['user'] } });
  const updateCollected = useUpdateParticipationCollected();

  const handleFlyoutOpen = (open: boolean) => {
    if (!open) removeQueryParamByKey(USER_ID_KEY);
  };

  return (
    <>
      <div className="flex justify-between items-center mb-5">
        <div className="flex gap-2 items-center">
          <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Säljare</h1>
        </div>
      </div>

      <Card className="p-0">
        <ParticipationList
          items={participations.map(participationToListItem)}
          onRowClick={(userId) => setQueryParam(USER_ID_KEY, userId)}
          onCollectedChange={(userId, collected) => updateCollected.mutate({ userId, saleId, data: { collected } })}
          showCollected={context?.membershipRoles.includes(MembershipRole.Leader)}
        />
      </Card>

      <Flyout open={Boolean(userId)} setOpen={handleFlyoutOpen}>
        <ErrorFrame pendingFallback={<Loader absolute />}>
          {userId && <ParticipationPanel saleId={saleId!} userId={userId} />}
        </ErrorFrame>
      </Flyout>
    </>
  );
}
